import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { injectable } from 'tsyringe';
import { getSiteSettingsApiConfig } from '@gn-audio/core/api/site-settings/config/actions';
import { fetchSiteFeatures } from '@gn-audio/core/api/site-settings/fetch-site-features';
import { createElement } from '@gn-audio/core/common/templating';
import { BasketPlugin } from '../../models';
import { EcomDomainSelectorComponent } from './components/ecom-domain-selector/ecom-domain-selector.component';
import { getEcomDomains, getUserCountryCode } from './utilities';
import './basket-location-warning.plugin.scss';
import template from './basket-location-warning.plugin.html';
var BasketLocationWarningPlugin = /** @class */ (function (_super) {
    __extends(BasketLocationWarningPlugin, _super);
    function BasketLocationWarningPlugin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BasketLocationWarningPlugin.prototype.register = function (_a) {
        var translations = _a.translations;
        this.translations = translations;
        this.createUI();
    };
    BasketLocationWarningPlugin.prototype.unregister = function () {
        var _a, _b;
        (_a = this.selector) === null || _a === void 0 ? void 0 : _a.destroy();
        (_b = this.element) === null || _b === void 0 ? void 0 : _b.remove();
    };
    /**
     * Gets a boolean value indicating whether plugin should be registered.
     * @remarks The plugin should be registered in case:
     *  - Feature `SfccBasketLocationWarning` is enabled
     *  - `user.country` meta tag exists on the page
     *  - Current market locale is `en-us` (.com domain)
     *  - `user.country` meta tag has content not `US` and where ecom is enabled
     */
    BasketLocationWarningPlugin.prototype.shouldRegister = function () {
        return __awaiter(this, void 0, void 0, function () {
            var featureToggles, userCountryCode, ecomEnabledForUserCountry, marketLocale;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchSiteFeatures(["SfccBasketLocationWarning" /* SiteFeature.SfccBasketLocationWarning */])];
                    case 1:
                        featureToggles = _a.sent();
                        if (featureToggles.length > 0 && !featureToggles[0].value) {
                            return [2 /*return*/, false];
                        }
                        userCountryCode = getUserCountryCode();
                        if (!userCountryCode) {
                            return [2 /*return*/, false];
                        }
                        ecomEnabledForUserCountry = getEcomDomains().some(function (x) { return (x.code === userCountryCode); });
                        marketLocale = getSiteSettingsApiConfig().marketLocale;
                        return [2 /*return*/, marketLocale === 'en-us'
                                && ecomEnabledForUserCountry
                                && userCountryCode !== "US" /* EcomCountryCode.UnitedStates */];
                }
            });
        });
    };
    BasketLocationWarningPlugin.prototype.createUI = function () {
        var target = document.querySelector(".basket-ui__header" /* BasketUIElementSelector.BasketHeader */);
        this.element = createElement(template, { country: this.getUserCountryName() }, this.translations);
        target.insertAdjacentElement('afterend', this.element);
        this.selector = new EcomDomainSelectorComponent();
        this.selector.render(this.element, this.translations);
    };
    BasketLocationWarningPlugin.prototype.getUserCountryName = function () {
        var userCountryCode = getUserCountryCode();
        var userCountryDomain = getEcomDomains().filter(function (x) { return (x.code === userCountryCode); })[0];
        return userCountryDomain.name;
    };
    BasketLocationWarningPlugin = __decorate([
        injectable()
    ], BasketLocationWarningPlugin);
    return BasketLocationWarningPlugin;
}(BasketPlugin));
export { BasketLocationWarningPlugin };
